import React from "react";
import empty from "../../assets/empty.svg";
import transactions from "../../data/transactionHistoryData";
import buy from "../../assets/buy.svg";
import transfer from "../../assets/transfer.svg";
import exchange from "../../assets/exchange.svg";
import invoice from "../../assets/invoice.svg";

function TransactionHistory() {
  const completedTransactions = transactions.filter(
    (transaction) => transaction.status === "success" || "failed" || "completed"
  );
  const pendingTransactions = transactions.filter(
    (transaction) => transaction.status === "in progress..."
  );

  //

  return (
    <div className="md:mt-[-80px] mt-[0] md:w-[70vw] w-[100vw]  px-[20px] md:mx-0 bg-[#FCFCF6] p-[36px] relative z-0 h-full">
      {transactions.length > 0 && (
        <div>
          <div>
            <h2 className="md:mb-[20px] font-bold "> Pending Transactions</h2>
            <hr />
            {pendingTransactions.map((transaction) => {
              let icon;

              if (transactions.type === "Buy") {
                icon = buy;
              } else if (transaction.type === "Transfer") {
                icon = transfer;
              } else if (transaction.type === "Exchange") {
                icon = exchange;
              } else if (transaction.type === "Invoice") {
                icon = invoice;
              } else if (transaction.type === "Sell") {
                icon = buy;
              }

              return (
                <div>
                  <div className="flex items-center justify-between my-[20px] ">
                    <div className="flex gap-[20px] items-center  ">
                      <div className="bg-[#FBC108]/10 w-[40px] h-[40px] rounded-full flex items-center justify-center ">
                        <img src={icon} alt="" />
                      </div>
                      <div>
                        <h1 className="font-semibold">
                          {transaction.type} {transaction.item}
                        </h1>
                        <p className="flex gap-2 items-center md:text-sm">
                          <span className="text-[#C90000] ">
                            {transaction.status}
                          </span>
                          <span className="text-[#929191] ">
                            {transaction.date} at {transaction.time}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="">
                      <div className="w-[100px] ">
                        <p className="font-semibold">
                          {transaction.value}{" "}
                          <small className="text-[#000000]/70 ">
                            {transaction.item}
                          </small>
                        </p>
                        <p className="text-[#000000]/60 ">
                          {transaction.valueInUSD}.00
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              );
            })}
          </div>
          <div className="mt-[41px] ">
            <h2 className="md:mb-[20px] font-bold"> Completed</h2>
            <hr />
            {completedTransactions.map((transaction) => {
              let icon;

              if (transaction.type === "Buy") {
                icon = buy;
              } else if (transaction.type === "Transfer") {
                icon = transfer;
              } else if (transaction.type === "Exchange") {
                icon = exchange;
              } else if (transaction.type === "Invoice") {
                icon = invoice;
              }
              return (
                <div>
                  <div className="flex items-center justify-between my-[20px] ">
                    <div className="flex gap-[20px] items-center  ">
                      <div className="bg-[#FBC108]/10 w-[40px] h-[40px] rounded-full flex items-center justify-center ">
                        <img src={icon} alt="" />
                      </div>
                      <div>
                        <h1 className="font-semibold">
                          {transaction.type} {transaction.item}
                        </h1>
                        <p className="flex gap-2 items-center md:text-sm">
                          <span className="text-[#C90000] ">
                            {transaction.status}
                          </span>
                          <span className="text-[#929191] ">
                            {transaction.date} at {transaction.time}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="w-[100px] ">
                        <p className="font-semibold">
                          {transaction.value}{" "}
                          <small className="text-[#000000]/70 ">
                            {transaction.item}
                          </small>
                        </p>
                        <p className="text-[#000000]/60 ">
                          {transaction.valueInUSD}.00
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              );
            })}
          </div>
        </div>
      )}

      {transactions.length === 0 && (
        <div className="flex flex-col items-center justify-center text-center">
          <img
            src={empty}
            alt=""
            className="md:mb-[48px] mb-[20px] w-[170px] md:w-auto "
          />
          <p className="text-[#000000]/60 text-sm md:text-base">
            Whoops! No recent transaction found
          </p>
          <p className="text-[#000000]/40 text-xs md:text-sm ">
            You will see all your recent transactions here
          </p>
        </div>
      )}
    </div>
  );
}

export default TransactionHistory;
